//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MedicamentConfigureDrawer from "./modules/MedicamentConfigureDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api'; // 站点树展示

import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'; //人员类型

import { queryUserTreeList } from '@/api/api';
export default {
  name: 'MedicamentConfigureList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    MedicamentConfigureDrawer: MedicamentConfigureDrawer
  },
  data: function data() {
    return {
      addDisabled: false,
      userTree: [],
      //人员信息
      pagePath: '/om/medicament/configure',
      pageTitle: '药剂配置',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '配置人员',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'drugName',
        colName: 'drug_name',
        title: '药品名称',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'configureDate',
        colName: 'configure_date',
        title: '配置时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'drugUsage',
        colName: 'drug_usage',
        title: '药品使用量',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'useUnit_dictText',
        colName: 'use_unit',
        title: '药品使用量单位',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'drugUse',
        colName: 'drug_use',
        title: '药剂用途',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'parameters',
        colName: 'parameters',
        title: '药品参数',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'concentration',
        colName: 'concentration',
        title: '配置浓度',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'concentrationUnit_dictText',
        colName: 'concentration_unit',
        title: '配置浓度单位',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'dosage',
        colName: 'dosage',
        title: '配药量',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'dosageUnit_dictText',
        colName: 'dosage_unit',
        title: '配药量单位',
        align: 'center',
        sorter: false
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.loadTreeList();
  },
  //站点树监视
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    handleAdd: function handleAdd() {
      var siteId = this.queryParam.siteId;
      this.$refs.modalForm.add(siteId);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    onDateConfigureDate: function onDateConfigureDate(value, dateArray) {
      this.queryParam.configureDateStart = dateArray[0];
      this.queryParam.configureDateEnd = dateArray[1];
    }
  }
};